const getLocalizeLanguage = async ({
  shouldAutomaticallyTranslate,
  locale,
}: {
  shouldAutomaticallyTranslate: boolean
  locale: string
}) => {
  if (Localize && shouldAutomaticallyTranslate) {
    const targetLocale = new Intl.Locale(locale)

    const availableLanguages = await new Promise<string[]>((resolve, reject) => {
      Localize.getAvailableLanguages((err, languages) => {
        if (err) {
          reject(err)
        } else {
          resolve(languages.map(({ code }) => code))
        }
      })
    })

    const availableLocales = availableLanguages.map((l) => new Intl.Locale(l))

    const exactMatch = availableLocales.find((l) => l.baseName === targetLocale.baseName)
    const languageMatch = availableLocales.find((l) => l.language === targetLocale.language)

    return exactMatch?.baseName ?? languageMatch?.baseName ?? 'en-US'
  } else {
    return 'en-US'
  }
}

export default getLocalizeLanguage
